import React from "react";

const KetentuanLayananEN: React.FC = () => (
  <>
    <p>
      These Terms and Conditions (&quot;<strong>Terms and Conditions</strong>
      &quot;) set out an agreement between PT IQ Edukasi, a limited liability
      company duly established under the laws of the Republic of Indonesia
      having its domiciled in Jakarta Selatan together with its affiliates
      (&quot;<strong>we</strong>&quot;, &quot;<strong>our</strong>&quot;, &quot;
      <strong>Colearn</strong>&quot;, or &quot;<strong>us</strong>) and any of
      the person (a natural person) who access and/or use (&quot;
      <strong>User</strong>
      &quot;, “<strong>you</strong>”, “<strong>your</strong>”)
      https://colearn.id or CoLearn® mobile application or any of other
      application, website, feature, technology, content, and digital products
      (&quot;<strong>Platform</strong>&quot;) owned and/or operated by us.
    </p>
    <p>
      By accessing or using our Platform, you hereby represent and warrant to us
      that you are eligible under law to be a User, i.e., either: (i) you are
      not under the age of 18 (eighteen) years old; (ii) you have obtained the
      consent from your legal guardian or parents (as applicable) if you are
      under the age of 18 (eighteen) years old or under guardianship and such
      use is made available or consented by your legal guardian or parents; or
      (iii) you are already married. You acknowledge that we do not have the
      responsibility to ensure that you conform to the aforesaid eligibility
      criteria. It shall be your sole responsibility to ensure that you meet the
      required qualification.
    </p>
    <p>
      It is clarified that CoLearn will not be responsible for any consequence
      that may arise as a result of misuse of our Platform or use of our
      services that may occur by virtue of any person including a person not
      qualified as aforesaid registering for the use of our Platform or
      services. If the User does not meet such eligibility conditions, then the
      User&#39;s action to register, access, use or carry out other activity in
      our Platform shall be deemed to be under the supervision and legal
      approval of their parent or guardian. The parent or guardian who has
      consented or deemed to have consented (as aforesaid) to the User under 18
      (eighteen) years old or under the guardianship (as the case may be) shall
      be fully responsible for all activities of the User in the use of and
      access to our Platform or services. If User do not qualify the same, then
      Users are not permitted User and should immediately cease to access the
      Platform or information available therefrom.
    </p>
    <p>
      You represent and warrant that by registering and/or using our Platform,
      the User and/or the parent or guardian of the User (if the User is under
      18 years old) is deemed to have read, understood and agreed to all terms
      and content in this Terms and Conditions together with
      amendments/revisions by CoLearn from time to time.
    </p>
    <p>
      IF THE USER DOES NOT AGREE WITH THESE TERMS AND CONDITIONS, THEN THE USER
      SHALL NOT CONTINUE TO ACCESS AND USE CoLearn PLATFORM/SERVICES/CONTENT.
    </p>
    <ol type="A">
      <li>
        <strong>
          Registering for an Account
          <br />
        </strong>
        Before using the Platform, Users agree to these Terms and Conditions,
        and Privacy Policy (together with changes made in it from time to time)
        entirely and register themselves by providing the information we require
        and also confirm of User eligibility including sound mental health. When
        registering, we will ask the User to provide his full name, e-mail
        address and personal mobile telephone number (including of User parent
        or lawful guardian, if the User is under 18 (eighteen) years old). We
        may monitor and also block your access to Platform if in the future the
        data/information that User provide to us is proven to be incorrect or we
        note of any violation of the terms (including laws) applicable to access
        to our Platform(s), contents and information’s accessible as User.
        <p>
          When the User has registered, we will provide the User with an access
          code that the User can use to access and use the CoLearn’s
          Platform/service/content (“<strong>Access Code</strong>”). The User is
          prohibited to allow anyone to use his/her user account or allow third
          person to otherwise access or use the Platform (including contents and
          data therein or ultimately sourced therefrom).
        </p>
        <p>
          Except to the extent specifically permitted, do not share (or allow
          access to) the Access Code information or data in the Platform with
          anyone. The User is fully responsible for maintaining the
          confidentiality and security of the Access Code, access to Platform
          and for all activities (including information or content accessible or
          sourced through the Platform) that occur against or through the Access
          Code, and the User agrees to immediately notify us in writing (email
          suffice) of any security breach of the Access Code. We are not
          responsible for any losses arising from misuse or unauthorized use of
          the Access Code (including information or content accessed or
          accessible through the Platform).
        </p>
        <p>
          We will consider any use or order made through a User&#39;s Account as
          a legitimate request from a User. Please notify us immediately if the
          User knows or suspects that the User&#39;s Account has been used
          without the User&#39;s knowledge and consent. We will take actions
          that we deem necessary and can be carried out against the use without
          that consent.
        </p>
      </li>
      <li>
        <strong>
          Personal Data of the User
          <br />
        </strong>
        Collection, storage, processing, use and sharing of User&#39;s personal
        data, such as the name, e- mail address, and personal mobile telephone
        number provided when the User opens an Account will be subject to the
        Privacy Policy, which is an inseparable part of these Terms and
        Conditions.
        <br />
        <p>
          Further we may, also share some Personal Data of User to certain third
          parties, such as email, IP address, or information about the browser,
          device identification number, or operating system you used or
          analytical data arising therefrom with the third party such as
          advertisers, advertising agencies, and/or advertising intermediaries,
          relevant information needed to select and offer suitable
          advertisements to you and other users which could be a third party
          product advertisement on an as-is basis, including information
          contained in cookies or other online identifiers (if it contains
          Personal Data). In case of any third-party advertisement, we do not
          solicit usage, approve quality or recommend the use of any third-party
          product or services advertised. Accordingly, notwithstanding any
          terms, no claim should be made against CoLearn or its representatives
          for your decisions/action.
        </p>
      </li>
      <li>
        <strong>
          Access to the Platform
          <br />
        </strong>
        We do not guarantee that our Platform, or the content in it, will always
        be available or uninterrupted. Permission to access our Platform is
        temporary. We may suspend, withdraw, terminate or replace any part of
        our Platform without prior notice. If you or in case of you being of the
        age less than 18 (eighteen) years, then your parent or legal guardian do
        not agree with the Terms and Conditions or the Privacy Policy, please do
        not use the CoLearn Platform or Website or avail the services or
        products. Any access to our services/Platform/content through
        registrations/subscription is non-transferable and should be used by the
        registered User only. We are not responsible for any reason that makes
        our Platform unavailable at certain times or periods.
        <p>
          You also agree to take all reasonable steps to stop the unauthorized
          use and to cooperate with us in any investigation of such unauthorized
          uses or breach. We shall not under any circumstances be claimed to be
          liable for any claims related to the use or misuse of your Account due
          to the activities of any third party or due to your failure to
          maintain the confidentiality, control or security of your access or
          Account, product and system used for availing our services.
        </p>
        <p>
          Quality of Streaming: The resolution and quality of the educational
          content you receive will depend on a number of factors, including the
          type of compatible device on which you are accessing the
          Platform/content and your internet bandwidth, which may increase or
          decrease over the course of your viewing or use of the Platform. While
          we strive to provide you a high-quality viewing experience, we make no
          guarantee as to the resolution or quality of the content in our
          Platform you will receive when streaming or displayed in your device.
        </p>
      </li>
      <li>
        <strong>
          Subscription and No-refund
          <br />
        </strong>
        If you (and in case of you being of the age less than 18 (eighteen)
        years, then your parent or legal guardian) do not agree or deemed to
        irrevocably agree with the Terms and Conditions and the Privacy Policy
        in entirety, please do not register or use the CoLearn Platform or
        Website or avail the services or products (as applicable). You agree
        that certain services/Product on our Platform are available subject to
        pre-payment of subscription fee (as per the applicable terms of the
        product and applicable subscription fees as communicated vide our
        product page) and may not be available to you unless you duly complete
        the subscription process and then make payment of the applicable
        Subscription Fees to our designated bank account. Unless provided
        otherwise in our Platform for the relevant subscribed Product/services,
        the applicable Subscription Fees are non-negotiable, final and required
        to be paid in advance.
        <p>
          <strong>NO-REFUND:</strong> Please read the subscription terms and
          conditions carefully before subscribing to any of the subscription
          plans, as once the User has subscribed to a plan and made the payment
          to us, it is understood that there shall be no option to change,
          adjust or cancel your subscription plan and no refund or credits of
          any form shall be allowed, irrespective of whether the services have
          been availed or not. Provided, CoLearn at its sole discretion may
          choose to offer refundability and/or up-grading the subscription plan
          purchased during the offer period (until revoked by CoLearn) subject
          to terms of such offers existing at the time of subscription of
          plan/package. Currently, CoLearn desires to offer refundability for
          newly subscribed live-classes packages of CoLearn by new Users,
          subject to following eligibility:
          <ol type="a">
            <li>
              Applicable only to new student enrolled with CoLearn for the first
              time;
            </li>
            <li>
              If the student has attended 80% of the live classes in the initial
              1 month of the start of subscribed live classes;
            </li>
            <li>
              The claim for such refund by eligible user can be made within 14
              days immediately following the end of initial 1 month of the newly
              subscribed package by such new user/new student, as the case may
              be. It is clarified that all such refund claim:
              <ol type="i">
                <li>
                  Should be requested via. WhatsApp no. registered with CoLearn
                  by sending clear WhatsApp message to our WhatsApp no.
                  +6281119103018 (message only);
                </li>
                <li>
                  Subject to such New User’ Parent/guardian availability for
                  Claim verification call and process document, forthwith
                  CoLearn will within 7 (Seven) working days therefrom, process
                  such refund of the subscription amount paid by such New User
                  for their new subscription qualified for refund claim as
                  aforesaid.
                </li>
              </ol>
            </li>
          </ol>
        </p>
        <p>
          the CoLearn may use AI / machine learning for better delivery of
          services/product or improvisation of services/ product, better
          communication or its analysis for improvisation of our Product or our
          better sales/marketing communication; and the same may involve feeding
          such information into such tools made available to us and owned by
          third party service providers (including open-source AI). Please note
          that technology is evolving and in spite of our endeavor to minimize
          Error, we may not be able to assure it being error-free and no claim
          arise therefrom. Accordingly, use of our Services/product is subject
          to such disclaimer. However, as we continuously endeavor to
          improvising on Services and User experience, please help us by letting
          us know your feedback to our WhatsApp (message only) no.
          +6281119103018 / email id.{" "}
          <a href="mailto:info@colearn.id">info@colearn.id</a> and we will take
          reasonable action!
        </p>
        <p>
          Further, it is agreed that you may choose an eligible/acceptable third
          party as a payment method/intermediary at your discretion and
          responsibility to subscribe to our platform/product/services. It is
          clarified that we shall not be responsible for or be made party to any
          such disputes between You and such third party and you shall at all
          time defend/hold us (including our representatives and affiliates)
          harmless against any claim, cost or expenses arising therefrom.
        </p>
        <p>
          You represent and warrant that any information that is provided to us
          is accurate, true and current. Any deviation from this will result in
          immediate cancellation of services and User access to our Platform at
          our sole discretion with no notice or refund/credit of any form.
        </p>
      </li>
      <li>
        <strong>
          Prohibited Uses
          <br />
        </strong>
        <p>
          Our platform can only be used by User for things that are justified by
          law and permitted by these Terms and Conditions. Without limitation,
          User using directly or indirectly our Platform (including
          contents/data accessed therefrom) for the following is not permitted:
        </p>
        <ol type="a">
          <li>
            In ways that violate applicable local, national, and international
            laws and regulations;
          </li>
          <li>
            In ways that are unlawful or deceptive, or have unlawful or
            deceptive purposes or effects;
          </li>
          <li>
            For the purpose of endangering or trying to harm a minor (including
            but not limited to any tutors, students and representatives
            associated in any capacity with CoLearn) in any way;
          </li>
          <li>
            Sending, accepting, uploading, copying, plagiarism, downloading
            (including screenshot or in screen recording/sharing), morphing,
            displaying using or reusing material that is not in accordance with
            our content standards, Terms and Condition and/or applicable laws;
          </li>
          <li>
            Distributing, sharing, casting or sending unwanted or unauthorized
            advertising or promotional material, and other forms of similar
            request (such as spam);
          </li>
          <li>
            Forwarding data, sending or uploading material containing viruses,
            trojans, worms, logic bombs, keystroke loggers, spyware, adware, or
            other malicious programs or similar computer code designed to have a
            detrimental effect the operation of any software or hardware of
            Platform in any manner.
          </li>
        </ol>
        <p>The user hereby agrees to:</p>
        <ol type="a">
          <li>
            Not to, whether directly or indirectly, reproduce, duplicate, copy,
            spoof, morph, cast, share or resell any part of our Platform
            (including any content/that contained/accessed in the Platform) that
            conflicts with the provisions in the Terms and Conditions of our
            Platform;
          </li>
          <li>
            To not access unauthorised, disruptive, destructive, or ruffled:
            <br />
            <ol type="i">
              <li>any part of our Platform;</li>
              <li>equipment or networks on which our Platform is stored;</li>
              <li>any software used in the provision of our Platform; or</li>
              <li>
                equipment or networks or software owned by any third party.
              </li>
            </ol>
          </li>
        </ol>
        <p>
          <strong>In-App Downloading</strong>:&nbsp;You are granted license only
          for in-app download of the educational content in the mobile
          application or on such Compatible Device so permitted. Screen-casting
          or downloading on any other device or in any manner not permitted
          herein shall amount to immediate termination of Subscription along
          with termination of access to all downloaded educational content with
          a right to initiate appropriate legal action, at our sole discretion.
        </p>
      </li>
      <li>
        <strong>Child Safety Policy</strong>
        This policy is applicable to all persons and organizations associated
        with us, including:
        <ol type="a">
          <li>
            Employees of CoLearn, who maybe full- time or part-time employees,
            permanent or contract employee;
          </li>
          <li>
            Organizations and persons belonging to that organization, who may
            partner and/or work with CoLearn in any capacity, even for a limited
            time period or job;
          </li>
          <li>
            Volunteers who may work with CoLearn, in whichever capacity, even
            for a limited period of time;
          </li>
          <li>
            Children enrolled as students of CoLearn and their parents or
            guardians who associate with the child in the official records of
            CoLearn;
          </li>
          <li>
            Children who may not be enrolled but are reached out through
            marketing or sales of the product and their parents or guardians who
            associate with the Child; and
          </li>
          <li>
            Any other person or organisations who may be officially associated
            with CoLearn and its ambit of work and activity.
          </li>
        </ol>
        <br />
        <p>
          In instances and circumstances where CoLearn may not have required
          control over the person alleged of any concern under this policy,
          including an instance of child abuse, CoLearn will endeavour to
          provide the reasonably required cooperation, assistance and support to
          such parent or guardian of the affected child, in approaching any
          external, legal mechanism including the Police and/or the Courts,
          though CoLearn is not personally liable or obligated in such
          instances.
        </p>
      </li>
      <li>
        <strong>
          Intellectual Property Rights
          <br />
        </strong>

        <p>
          The User acknowledge and unconditionally agree that our Platform,
          including but not limited to any content contained on the Platform,
          name, logo, program code, design, trademark, technology, database,
          content and business process and model, are perpetually and globally
          proprietary to CoLearn and are protected contractually herein and
          under laws related to proprietary rights, copyright, trademark,
          patent, moral rights and other intellectual property rights are
          perpetually and globally owned by Us or our affiliates. Use of the
          Platform content and content is subject to and refers to these Terms
          and Conditions. The content, images, sounds, publications and videos
          on the Platform or otherwise by us should only be used by User intact
          as is without any change, for personal and non-commercial use needs.
          It is forbidden to download and otherwise use that may violate these
          Terms and Conditions and applicable laws.
        </p>
        <p>
          Except to the extent specifically permitted by CoLearn in writing, the
          User shall not change/alter paper or digital copies of any material
          that the User has printed or downloaded in any way other than as
          subject terms specifically permitted within the Platform and the User
          should not use illustrations, photographs, video or audio clips, or
          other graphics separately from his/her accompanying text.
        </p>
        <p>User are prohibited from:</p>
        <div>
          <ol type="a">
            <li>
              copy, modify, print, adapt, translate, create counterfeit works
              from, distribute (other than sharing as may be facilitated through
              CoLearn platform itself), license, sell, move, publicly display,
              duplicate, transmit, broadcast via online or offline media, use
              for AI training (including tuning/embedding, etc.), machine
              learning, cut, unpack, or otherwise exploit any part of our
              Platform, including but not limited to paid/free content and
              materials on the Platform or otherwise, whether physical or
              digital, are perpetually and anywhere globally irrespective of
              subscription period or post-completion of the Platform
              subscription;
            </li>
            <li>
              license, derivatives the license, sell, resell, transfer, assign,
              distribute, or otherwise exploit or commercially or otherwise
              share our contents, Platform and/or other software associated with
              our Platform (including our content or data) in any way;
            </li>
            <li>
              create internet &#39;links&#39; to our Platform, or spoof/adapt (
              <em>frame</em>), or compute (<em>mirror</em>) any software on
              servers or wireless devices, IP, or other internet- connected
              devices;
            </li>
            <li>
              reverse engineer or access our Platform to (i) build competitive
              products or services; (ii) build products based on ideas,
              features, functionality or graphics similar to our Platform; or
              (iii) copy ideas, features, functions or graphics on our Platform;
            </li>
            <li>
              launching automated programs or scripts including, but not limited
              to, web spiders, web crawlers, web robots, web ants, web indexing,
              bots, viruses, worms, or any program that may increase server
              requests per second, or make loads too heavy that interfere with
              the operation and/or performance of our Platform;
            </li>
            <li>
              use robots, spiders, site search or retrieval applications, or
              other manual or automated equipment and processes to retrieve,
              index, mine data, AI training (including tuning/embedding, etc.),
              machine learning, or in any way duplicate, unauthorised usage, or
              circumvent the navigation structure or appearance of our Platform
              or its content;
            </li>
            <li>
              post, distribute, unauthorised publication/usage or duplicate in
              any way Contents published by CoLearn or our representatives,
              contents/material with our copyright, trademark, or other
              proprietary information without previously obtaining the consent
              of the owner of the proprietary rights viz. CoLearn; and
            </li>
            <li>
              alter or remove any copyright, trademark or other proprietary
              rights notices contained in our Platform. No license or right is
              granted to a User implicitly or otherwise based on intellectual
              property rights owned or controlled by us and our licensors,
              except for the limited licenses and rights expressly granted in
              these Terms and Conditions for permitted use only by registered
              User. Users shall not use any part of the content on our Platform
              for commercial purposes without previously obtaining a license to
              do so from us or our licensors through us.
            </li>
          </ol>
        </div>
        <p>
          Our status (and the status of other contributors that we have
          identified) as authors and/or exclusive owner of the content on our
          Platform (including accessible through Platform) and Platform itself
          must always be recognized and honoured. It is also clarified that the
          CoLearn’s content (are non-AI generated) accessible through our
          Platform or otherwise are authored (including supervised) by our
          expert employees or consultants solely for CoLearn and are exclusively
          owned by CoLearn perpetually and worldwide. Further, we reserve all
          right in all our proprietary assets both tangible and intangible.
        </p>
        <p>
          If the User prints, copies, or downloads any part of our Platform
          (including our contents) that violates these Terms and Conditions,
          then without limiting Co-learn’s other rights and remedy that may be
          available to us under these terms, law and equity, the User’s right to
          use our Platform will be immediately terminated at our discretion and
          the User must, at our decision, return or destroy a copy of the
          material the User has made or possess.
        </p>
        <p>
          We reserve our right to investigate or prosecute any form of violation
          of the Terms and Conditions above in accordance with applicable legal
          provisions. We may involve and cooperate with the authorities in suing
          users who violate these Terms and Conditions. The User acknowledges
          that we are not obliged to monitor User access to our platform, but we
          have the right to do so with the aim of operating our Platform,
          ensuring the User’s compliance with these Terms and Conditions, or to
          obey applicable laws or decisions of courts, administrative bodies or
          other government bodies.
        </p>
      </li>
      <li>
        <strong>
          Uploading Content on Our Platform
          <br />
        </strong>
        The User may use features that allow User to upload legitimate and
        permitted content or materials to our Platform, or to connect with other
        User of our Platform through interactive services (&quot;
        <strong>Content</strong>&quot;). Provided that the Content is not
        justified in connection with the following.
        <div>
          <ol type="a">
            <li>Contains material that defames someone;</li>
            <li>
              Contain material that is obscene, offensive, hateful, or
              inflammatory;
            </li>
            <li>
              Promote content related to gambling, sweepstakes and/or betting;
            </li>
            <li>Promote sexually explicit or immoral material;</li>
            <li>Promoting violence;</li>
            <li>
              Promote discrimination based on race, gender, religion,
              nationality, disability, sexual orientation, or age;
            </li>
            <li>Promoting hacking and/or cracking services;</li>
            <li>
              Promoting access to fraudulent products, money laundering,
              multi-level marketing schemes, and pirated products;
            </li>
            <li>Promoting access to human trafficking and human organs;</li>
            <li>Promote access to illicit substances and narcotics;</li>
            <li>Promoting access to cigarettes and tobacco-based materials;</li>
            <li>
              Promote unauthorized sale of products that require a license (e.g.
              drugs, explosives, firearms, etc.);
            </li>
            <li>
              Violate any intellectual property rights including copyright,
              database right, or other people’s trademarks;
            </li>
            <li>
              Made in violation of any legal obligations to third parties, such
              as contractual obligations or confidentiality obligations;
            </li>
            <li>Promote any unlawful activity;</li>
            <li>
              Threaten, abuse, or invade the privacy of others, or cause
              unnecessary interference, inconvenience, or anxiety;
            </li>
            <li>May harass, offend, humiliate, alarm, or harass anyone;</li>
            <li>
              Used to impersonate another person, or to forge your identity or
              affiliation with another person;
            </li>
            <li>Suggest that the Content is from us, when it is not; and</li>
            <li>
              Advocate for, promote, or assist in unlawful actions such as (for
              example only) copyright infringement or computer misuse.
            </li>
          </ol>
        </div>
        <p style={{ paddingLeft: "40px" }}>
          The User guarantees that such Content complies with the standards set
          forth, and that The User will be solely responsible to us and
          indemnify us for any breach of such guarantee. Accordingly, the User
          will be liable for any loss or damage we suffer as a result of a
          breach of the User’s guarantee.
        </p>
        <p style={{ paddingLeft: "40px" }}>
          All Content that User upload to our Platform will be considered
          non-confidential, non-proprietary and does not violate the
          intellectual property rights of any party, unless the User declares
          otherwise to us. The User retain all ownership rights to the User
          Content, but User are required to grant us a limited license to use,
          store and copy such Content, and to distribute and make it available
          to third parties.
        </p>
        <p style={{ paddingLeft: "40px" }}>
          We also reserve the right to disclose a User’s identity to any third
          party claims that the Content User posted or uploaded is a violation
          of their intellectual property rights, or their privacy rights.
        </p>
        <p style={{ paddingLeft: "40px" }}>
          We reserve the right to delete any Content that User upload on our
          Platform if, in our opinion, the User Content does not comply with the
          content standards set forth in these Terms and Conditions.
        </p>
        <p style={{ paddingLeft: "40px" }}>
          We are not responsible or liable by any third party, for the Content
          or the accuracy of any Content that User upload to our Platform.
        </p>
      </li>
      <li>
        <strong>
          Actions We Deem Necessary
          <br />
        </strong>
        If we know or have sufficient reason to suspect that the User has
        committed immoral acts, violations, crimes or other actions that are
        contrary to these Terms and Conditions and/or applicable laws and
        regulations, whether or not they are referred to in these Terms and
        Conditions, then we have the right to and can freeze accounts, either
        temporarily or permanently, or terminate your access to the Platform,
        carry out checks, claim compensation, report to the authorities and/or
        take other actions that we deem necessary, including criminal and civil
        legal actions.
        <br />
        <br />
        We will follow up with an investigation and/or facilitate the parties
        concerned to report to the authorities if we receive a report of a
        violation that the user has done to these Terms and Conditions or a
        violation of applicable laws and regulations, relating to verbal
        harassment or violence, including but not limited to, physical, gender,
        ethnicity, religion and race.
        <br />
        <br />
      </li>
      <li>
        <strong>
          Creating Links to Our Platform
          <br />
        </strong>
        The User can link to our Platform, provided that the User do it in a way
        that is fair and legal and does not damage our reputation or take
        advantage of it.
        <br />
        <br />
        The User are not allowed to make links in such a way as to give the
        appearance of an association, agreement, or support from us when it is
        not true.
        <br />
        <br />
        The User are not allowed to link to our Platform on any website that is
        not owned by the User. We reserve the right to revoke permission for
        link creation without notice.
        <br />
        <br />
      </li>
      <li>
        <strong>
          Third Party Links on Our Platform&nbsp;
          <br />
        </strong>
        Where our Platform contains links and access to websites and other
        content provided by third parties, we have no control over the content
        of this web sites or resources. We are not responsible for any part of
        the content provided by third parties. Access or use of the User to such
        third party content is a form of User’s agreement to comply with the
        Terms and Conditions and privacy policy set by the third party.
        <br />
        <br />
      </li>
      <li>
        <strong>Liability of the User</strong>
        <br />
        The User are fully liable for every damage and/or claim arising out of
        the use of the Platform through the User’s account, whether by yourself
        or any other party using your account, in any manner contradictory to
        these Terms and Conditions, applicable laws and regulations, violation
        of any intellectual property rights and/or other activities that may
        harm the public and/or any other party or which may violate or may be
        considered as violating our reputation. We do not guarantee that the
        Platform will be safe or clear from bugs or viruses. The User are
        responsible to manage suitability, safety, security of the information
        technology, Access Code, computer program and your platform that you use
        to access our Platform/services/content (including your sole
        responsibility to ensure confidentiality and permitted access or use of
        our Platform and contents). The User shall use your own software,
        compatible device and your own anti-virus.
        <br />
        <br />
        You agree to indemnify, defend and hold harmless CoLearn, its officers,
        directors, employees, consultants and agents, from any and all claim
        including third party claims, liability, damages and/or costs (including
        but not limited to advisors or legal fees) arising from Your use of the
        Platform or services, or any infringement or violation by You or any
        other user of Your account, of any Terms and Conditions including
        intellectual property or other right of any person or entity, or
        applicable laws and policies together with its amendments from time to
        time.
        <br />
        <br />
      </li>
      <li>
        <strong>
          Disclaimer and Limitation of Liability
          <br />
        </strong>
        The User understands and agrees that the services in our Platform are
        provided “as is” and “as available” basis. To the fullest extent
        possible by applicable laws and regulations, we do not, expressly or
        impliedly, make any warranties, support or make any representations in
        connection with the provision of services or content on our Platform,
        which includes&nbsp; and not limited to:&nbsp; no warranties of
        merchantability and suitability for a particular purpose and no
        infringement; and no guarantees that access to or use of the Platform,
        services or content will not be disturbed or disrupted or not any errors
        or errors on the Platform will be fixed.
        <br />
        <br />
        To the fullest extent permitted by applicable laws and regulations, in
        no case CoLearn, its officers, directors, employees, or agents, be
        liable to you for any direct, indirect, incidental, special, punitive,
        losses or expenses or consequential damages, or loss of data, use,
        goodwill, or other intangible losses, whatsoever resulting from or due
        to (i) User access to use or use of or inability to access or use the
        Platform; (ii) any actions or content provided by third parties relating
        to the Platform; (iii) unauthorized access, use or change of any content
        on the Platform; or (iv) other problems that have arisen not caused by
        our violation of these Terms and Conditions. To the extent permitted by
        applicable laws and regulations, our total responsibility/ liability for
        all claims arising from violations of these Terms and Conditions is
        limited to the amount the relevant User paid us for using services on
        our Platform at the time of claim.
        <br />
        <br />
        By using and accessing our Platform, the User agrees to independently
        verify the authenticity and truth of the answers, information, materials
        and content published in the Platform or website. Further, CoLearn makes
        no warranty or representation regarding the results that may be obtained
        from the use of the services on the Platform, regarding the accuracy or
        reliability of any information (including but not limited to the
        content, videos and data, etc.) obtained through the services on the
        Platform or that the Platform/services will meet any user’s
        requirements, or be uninterrupted, timely, secure or error free. Use of
        any material and/or data downloaded, viewed or otherwise obtained or
        accessed through the use of the Platform/services is at your own
        discretion and sole risk. The entire risk arising out of use or
        performance of the services remains with you. CoLearn does not assume
        any responsibility for retention of any user information or
        communications with or between User. CoLearn cannot guarantee and does
        not promise any specific results from use of the Platform/services. Use
        of the Platform and any actions that the User takes on the basis of
        information contained on the Platform are the User’s own responsibility
        and risk and we are not responsible for the consequences of the actions
        the User does.
        <br />
        <br />
      </li>
      <li>
        <strong>Force Majeure</strong>
        <br />
        Our Platform and availability of our services (in part or full) may be
        interrupted by events outside of our authority or control (“
        <strong>Force Majeure</strong>”), including but not limited to natural
        disasters, epidemic, riots, lock-down, power disruptions,
        telecommunications disruptions, change in applicable laws and government
        policies, and others. The User agrees to release us and our affiliates
        from any demands (including claim for refund) and responsibilities, if
        we cannot facilitate the service (in part or full), including fulfilling
        the instructions given by the user through the platform, either in part
        or in full, due to a Force Majeure.
        <br />
        <br />
      </li>
      <li>
        <strong>Language</strong>
        <br />
        These Terms and Conditions are governed by the laws of the Republic of
        Indonesia. Any and all disputes arising from the use of the Platform and
        these Terms and Conditions are subject to the exclusive jurisdiction of
        the South Jakarta District Court.
        <br />
        <br />
      </li>
      <li>
        <strong>
          Bahasa
          <br />
        </strong>
        These Terms and Conditions is made in Indonesian language and English
        language. In the event of any inconsistency or different interpretation
        between the Indonesian language version and the English language
        version, the User agrees that the Indonesian language version will
        prevail to the extent of such inconsistency or conflict (as required
        under applicable law), and the relevant English language version is
        deemed to be automatically amended to be consistent with the relevant
        part of the Indonesian language version.
        <br />
        <br />
      </li>
      <li>
        <strong>Communications</strong>
        <br />
        We may contact/send you promotions, our service/product information, our
        service/product feedback/review or otherwise communicate with you
        electronically, which may include e-mail, push notification (like in-app
        or message including via WhatsApp to your phone no., etc) and you hereby
        consent to receive those communications. These communications will be in
        accordance with our Privacy Policy.
        <br />
        <br />
      </li>
      <li>
        <strong>Other Provisions</strong>
        <br />
        <ol type="i">
          <li>
            The User understands and agrees that these Terms and Conditions
            constitute an electronic agreement by accessing our Platform and
            further confirmed by the action of the User pressing the ‘register’
            button when opening an Account or the ‘enter’ button when accessing
            a User Account is the User’s active agreement to enter into an
            agreement with us so that the terms and conditions are enforced and
            These Terms and Privacy Policy are legal and legally binding and
            continue to apply throughout the User’s use of the Platform,
            services and CoLearn data and to the extent it survive by its nature
            thereafter.
          </li>
          <li>
            Modification/Amendment: CoLearn reserves the right to modify,
            suspend, or discontinue the subscription service or plan, or any
            part of the subscription service or plan, at any time and without
            notice (except as mandatorily required by applicable law), by
            posting the revised terms in connection with services. To the
            maximum extent permitted by law, your continued use of the services
            following any changes will constitute your acceptance of such
            changes. We will not be liable to you should it exercise such
            rights, even if your ability to use CoLearn service /access to
            content is impacted by the change.
          </li>
          <li>
            We can revise these Terms and Conditions at any time by changing
            terms in this page. Please revisit this page from time to time to
            notice whether or not there have been any changes we made, because
            these changes will be binding on the User at all time.
          </li>
          <li>
            We may update the Platform from time to time and change its content
            at any time. However, please be aware that our Platform can have
            content that is not updated at certain times, and we are not
            responsible for updating it. We do not guarantee that our Platform,
            or the content contained therein, can be completely free from errors
            or omissions.
          </li>
          <li>
            User will not submit any claims or objections to the validity of the
            Terms and Conditions, or Privacy Policy created in electronic form.
          </li>
          <li>
            User cannot transfer User rights under these Terms and Conditions
            without our prior written consent. However, we may transfer our
            rights based on these Terms and Conditions at any time to other
            parties without the need to obtain prior approval from or provide
            prior notice to the User.
          </li>
          <li>
            If a User does not comply with or violates the provisions in these
            Terms and Conditions, and if We do not take action directly, it does
            not mean we waive our right to take the necessary action at a later
            date.
          </li>
          <li>
            These Terms and Conditions remain in effect even after a temporary
            freeze, permanent freeze, removal of the Platform or after the
            termination of this agreement between you and us.
          </li>
          <li>
            If one of the conditions in these Terms and Conditions cannot be
            applied, it will not affect the other provisions.
          </li>
          <li>
            The User can reach out to us including for any questions regarding
            these Terms and Conditions, please contact us via{" "}
            <a href="mailto:support@colearn.id">support@colearn.id</a>
          </li>
        </ol>
      </li>
    </ol>
    <p>
      Updated on:&nbsp;<strong>08 December 2023</strong>.
    </p>
  </>
);

export default KetentuanLayananEN;
